export default function AppSection() {
  return (
    <section id="app" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">移动客户端</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">随时随地，畅享高清影视体验</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-background-200/80 to-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-300/50 flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20interface%20mockup%20for%20movie%20streaming%20service%20with%20dark%20theme%20warm%20golden%20accents%20cinematic%20poster%20grid%20clean%20UI%20design%20minimal%20aesthetic%20no%20text&width=400&height=400&seq=app-icon-movie-01&orientation=squarish"
                  alt="大师兄影视移动客户端"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl font-heading text-foreground-100 mb-3">大师兄影视 App</h3>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                  专为移动端优化的观影体验，支持手机与平板。高清画质自适应、不缓冲秒开播放、极速加载流畅观影，更有离线缓存与多设备续播功能，让您随时随地畅享海量片库。
                </p>
                <div className="flex flex-wrap gap-3 justify-center md:justify-start">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-background-300/30 text-xs text-foreground-400">
                    <i className="ri-android-line text-primary-400"></i>
                    Android
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-background-300/30 text-xs text-foreground-400">
                    <i className="ri-apple-line text-primary-400"></i>
                    iOS
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-background-300/30 text-xs text-foreground-400">
                    <i className="ri-tablet-line text-primary-400"></i>
                    iPad
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-background-300/30 text-xs text-foreground-400">
                    <i className="ri-tv-line text-primary-400"></i>
                    智能电视
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}